<div class="modal-content" *ngIf="loaded">
  <div class="modal-header text-center p-3">
    <i aria-label="Close" (click)="handleClick({ close: true })" class="close pull-right align-middle fas fa-times"> </i>
    <h4 class="modal-title w-100">{{ 'baryApp.quotations.moderatorModal.confirm-cancellation.title' | translate }}</h4>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-12">
        <jhi-bary-input-textarea
          id="field_quotationRejectionMessage"
          [control]="getControl('quotationRejectionMessage')"
          [label]="'baryApp.quotations.moderatorModal.confirm-cancellation.quotationRejectionMessage' | translate"
        ></jhi-bary-input-textarea>
      </div>
    </div>
    <div class="row mt-1">
      <div class="col text-left">
        <form class="mt-2 text-left" name="form" role="form" (ngSubmit)="submit()" (keydown.enter)="submit()" [formGroup]="quotationForm">
          <div class="col-12">
            <div class="row">
              <div class="col-8">
                <div class="input"></div>
              </div>
            </div>
          </div>
          <div class="text-center">
            <jhi-bary-button
              class="mr-2"
              [color]="'danger'"
              [label]="'baryApp.quotations.moderatorModal.confirm-cancellation.submit' | translate"
              (click)="submit()"
            ></jhi-bary-button>
            <jhi-bary-button
              [color]="'white'"
              [label]="'baryApp.quotations.moderatorModal.confirm-cancellation.cancel' | translate"
              (click)="handleClick({ close: true })"
            ></jhi-bary-button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
